import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "contentRoot" }

import { onMounted } from 'vue'
    import { onBeforeRouteUpdate, useRoute } from 'vue-router'
    import type { RouteLocationNormalizedLoaded } from 'vue-router'

    import { send } from './AppRT'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ContentRoot',
  setup(__props) {

    const route = useRoute()

    function dispatch(to: RouteLocationNormalizedLoaded)
    {
        send('Runtime', 'DispatchHash', to.path)
    }

    // initial enter
    onMounted(() =>
    {
        dispatch(route)
    })

    // subsequent updates
    onBeforeRouteUpdate((to) =>
    {
        dispatch(to)
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("h3", { style: {"margin":"20px"} }, "Launching application...", -1 /* CACHED */)
  ]))]))
}
}

})